
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import PageLayout from '@/components/layout/PageLayout';
import RecipeUrlForm from '@/components/RecipeUrlForm';
import { useQueryClient } from '@tanstack/react-query';

const ImportRecipes = () => {
  const queryClient = useQueryClient();

  const handleRecipeAdded = () => {
    queryClient.invalidateQueries({ queryKey: ['recipes'] });
  };

  return (
    <PageLayout 
      title="Import Recipes" 
      description="Import recipes from recipe websites by entering the URL below"
    >
      <div className="max-w-2xl mx-auto">
        <Card>
          <CardHeader>
            <CardTitle>Import Recipe from URL</CardTitle>
          </CardHeader>
          <CardContent>
            <RecipeUrlForm onRecipeAdded={handleRecipeAdded} />
            <p className="text-xs text-muted-foreground mt-4">
              Supported sites include popular recipe websites. The system will automatically extract recipe information.
            </p>
          </CardContent>
        </Card>
      </div>
    </PageLayout>
  );
};

export default ImportRecipes;
